export const PLATFORM = "web";

const YOUR_ELEMENTS_INTERNAL_ROUTE = "/elements";

export const resolveTopicAction = (topic) => {
  const action = topic?.action;
  if (!action || action.type == null) {
    return { kind: "coaching" };
  }

  if (action.type === "navigation") {
    const target = action.targets?.[PLATFORM] || null;
    if (!target || !target.value) {
      return { kind: "unsupported", reason: "missing_target" };
    }
    return { kind: "navigation", target };
  }

  if (action.type === "coaching") {
    return { kind: "coaching" };
  }

  return { kind: "coaching", reason: `unknown_action_type:${action.type}` };
};

export const isYourElementsTopic = (topic) => {
  const resolved = resolveTopicAction(topic);
  if (resolved.kind !== "navigation") return false;
  const value = resolved.target?.value || "";
  return (
    resolved.target?.kind === "internal_route" &&
    value === YOUR_ELEMENTS_INTERNAL_ROUTE
  );
};

export const findYourElementsTopic = (categories) => {
  if (!Array.isArray(categories)) return null;
  for (const category of categories) {
    if (!Array.isArray(category?.topics)) continue;
    for (const topic of category.topics) {
      if (isYourElementsTopic(topic)) return { topic, category };
    }
  }
  return null;
};
